"use client";

import dynamic from "next/dynamic";

const BuzonSugerenciasForm = dynamic(
  () => import("@/components/BuzonSugerenciasForm"),
  {
    ssr: false,
  },
);

export default function BuzonSugerenciasPage() {
  return <BuzonSugerenciasForm aeropuerto="PTY" returnUrl="/pasajeros" />;
}
